import { useEffect, useRef } from "react";

const MapNaverJeju = () => {
  const mapElement = useRef(null);
  const { naver } = window;

  useEffect(() => {
    if (!mapElement.current || !naver) return;
    const parkingPoint = [
      { x: 37.51235, y: 127.054 },
      { x: 37.51245, y: 127.0528 },
    ];

    // 지도에 표시할 위치의 위도와 경도 좌표를 파라미터로 넣어줍니다.
    // architeco-geo -> 37.51273, 127.05315
    // architeco-geo-jeju -> 33.31253, 126.8361
    const location = new naver.maps.LatLng(33.31253, 126.8361);
    const mapOptions = {
      center: location,
      zoom: 18,
      // zoomControl: true,
    };

    const map = new naver.maps.Map(mapElement.current, mapOptions);
    new naver.maps.Marker({
      map: map,
      position: location,
      title: "회사",
      icon: {
        url: "/imgs/icon_office_point.png",
        size: new naver.maps.Size(180, 83),
        anchor: new naver.maps.Point(0, 83),
      },
    });

    const markers: any[] = [];

    naver.maps.Event.addListener(map, "idle", function () {
      updateMarkers(map, markers);
    });

    function updateMarkers(map: any, markers: any) {
      var mapBounds = map.getBounds();
      var marker, position;

      for (var i = 0; i < markers.length; i++) {
        marker = markers[i];
        position = marker.getPosition();

        if (mapBounds.hasLatLng(position)) {
          showMarker(map, marker);
        } else {
          hideMarker(map, marker);
        }
      }
    }
    function showMarker(map: any, marker: any) {
      if (marker.setMap()) return;
      marker.setMap(map);
    }

    function hideMarker(map: any, marker: any) {
      if (!marker.setMap()) return;
      marker.setMap(null);
    }
  }, []);

  return (
    <>
      <div ref={mapElement} style={{ width: "100%", height: "100%" }} />
    </>
  );
};

export default MapNaverJeju;
